/** @module EngineeringChange/AggregateECsController */
define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/_base/underscore",
	"csi/table/AggregateFrom"
], function(declare,lang,_,AggregateFrom) {
	return declare(AggregateFrom, {

		/**
		 * @override
		 * Add aggregate test
		 */
		getFormData: function() {
			let fd = this.inherited(arguments);
			fd.m_fAggregateTest = lang.hitch(this, this._canAggregate);
			return fd;
		},

		/**
		 * Return true if a EC is not in the list
		 * @param {Context} ctx
		 * @param {FormData} fd
		 * @return {boolean}
		 */
		_canAggregate: function(ctx, fd) {
			const productNode = this.m_urlParent && ctx.cache.getNode(this.m_urlParent);
			const isEC =productNode && _.find(ctx.cache.getNodes(productNode.AffectedItems), function(affectedItem) {
				return (ctx.getNodeURL() == affectedItem.__Parent__);
			});
			return !isEC;
		}
	});
});